import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, isDevMode, DEFAULT_CURRENCY_CODE, LOCALE_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { registerLocaleData } from '@angular/common'; // Nuevo
import localeEsAR from '@angular/common/locales/es-AR'; // Nuevo
import { EnhancedDialogService } from './services/enhanced-dialog.service';

// Registra el locale de español Argentina
registerLocaleData(localeEsAR); // Nuevo

import { StepsModule } from 'primeng/steps';
import { CardModule } from 'primeng/card';
import { CalendarModule } from 'primeng/calendar';

import { SidebarModule } from './sidebar/sidebar.module';
import { FooterModule } from './shared/footer/footer.module';
import { NavbarModule } from './shared/navbar/navbar.module';
import { MaterialModule } from './material/material.module';
import { DirectivesModule } from './directives/directives.module'; // Importar módulo de directivas

import { AppComponent } from './app.component';
import { AppRoutes } from './app.routing';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { ClientesComponent } from './pages/clientes/clientes.component';
import { DetalleClienteComponent } from './pages/clientes/detalle-cliente/detalle-cliente.component';
import { AsociarProductosDialogComponent } from './pages/clientes/detalle-cliente/asociar-productos-dialog.component';

import { InterceptorHeadersInterceptor } from './services/interceptor-headers.interceptor';

import { ProductosComponent } from './pages/productos/productos.component';
import { DetalleProductoComponent } from './pages/productos/detalle-producto/detalle-producto.component';
import { ComponenteDialogoComponent } from './pages/productos/detalle-producto/componente-dialogo/componente-dialogo.component';
import { ImpuestosDialogComponent } from './pages/productos/detalle-producto/impuestos-dialog/impuestos-dialog.component';
import { InfoDialogComponent } from './pages/productos/detalle-producto/info-dialog/info-dialog.component';
import { ResumenComponent } from './pages/clientes/resumen/resumen.component';
import { SaldoInicialDialogComponent } from './pages/clientes/resumen/saldo-inicial-dialog/saldo-inicial-dialog.component';
import { ConfirmarDialogComponent } from './pages/clientes/resumen/confirmar-dialog/confirmar-dialog.component';
import { VentasComponent } from './pages/ventas/ventas.component';
import { CajaComponent } from './pages/caja/caja.component';
import { AperturaComponent } from './pages/caja/apertura/apertura.component';
import { CierreComponent } from './pages/caja/cierre/cierre.component';

import { SettingsComponent } from './pages/settings/settings.component';
import { PuntoVentaComponent } from './pages/settings/punto-venta/punto-venta.component';
import { CreatePtoVentaComponent } from './pages/settings/punto-venta/create-pto-venta/create-pto-venta.component';
import { ListaPrecioComponent } from './pages/settings/lista-precio/lista-precio.component';
import { CreateListaPrecioComponent } from './pages/settings/lista-precio/create-lista-precio/create-lista-precio.component';
import { ProductosDialogoComponent } from './pages/settings/lista-precio/productos-dialogo/productos-dialogo.component';
import { ListaClienteCajaComponent } from './pages/caja/lista-cliente-caja/lista-cliente-caja.component';

import { ConfirmarCajaComponent } from './pages/caja/confirmar-caja/confirmar-caja.component';
import { MarcasComponent } from './pages/settings/marcas/marcas.component';
import { CreateMarcaComponent } from './pages/settings/marcas/create-marca/create-marca.component';
import { RubrosComponent } from './pages/settings/rubros/rubros.component';
import { CreateRubroComponent } from './pages/settings/rubros/create-rubro/create-rubro.component';
import { UploadFileComponent } from './shared/upload-file/upload-file.component';
import { ComprasComponent } from './pages/compras/compras.component';
import { ReportesComponent } from './pages/reportes/reportes.component';
import { ListaProductosDialogoComponent } from './pages/lista-productos-dialogo/lista-productos-dialogo.component';
import { FormatComprobantePipe } from './pipes/format-comprobante.pipe';
import { FormatPtoventaPipe } from './pipes/format-ptoventa.pipe';
import { FormatEstadoPipe } from './pipes/format-estado.pipe';
import { ComprobanteComponent } from './pages/comprobante/comprobante.component';
import { ListaClienteComponent } from './pages/comprobante/lista-cliente/lista-cliente.component';
import { ReporteStockComponent } from './pages/reportes/reporte-stock/reporte-stock.component';
import { EditarCantidadesComponent } from './pages/caja/editar-cantidades/editar-cantidades.component';
import { EmpresaComponent } from './pages/settings/empresa/empresa.component';
import { CheckauthComponent } from './pages/checkauth/checkauth.component';
import { TablaResponsivaComponent } from './shared/tabla-responsiva/tabla-responsiva.component';
import { DetalleFilaComponent } from './shared/tabla-responsiva/detalle-fila/detalle-fila.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { RecibosComponent } from './pages/clientes/recibos/recibos.component';
import { DialogComprobantesComponent } from './pages/clientes/recibos/dialog-comprobantes/dialog-comprobantes.component';
import { DialogMediosPagoComponent } from './pages/clientes/recibos/dialog-medios-pago/dialog-medios-pago.component';
import { ProductosProveedorComponent } from './pages/clientes/productos-proveedor/productos-proveedor.component';
import { PreciosMasivosComponent } from './pages/productos/precios-masivos/precios-masivos.component';
import { FileDragAndDropDirective } from './shared/file-drag-and-drop.directive';
import { VariantesArticuloComponent } from './pages/productos/variantes-articulo/variantes-articulo.component';
import { GoBackBtnComponent } from './shared/go-back-btn/go-back-btn.component';
import { TalonariosComponent } from './pages/settings/talonarios/talonarios.component';
import { CreateTalonarioComponent } from './pages/settings/talonarios/create-talonario/create-talonario.component';
import { TiendaComponent } from './pages/settings/tienda/tienda.component';
import { IntegrationDialogComponent } from './pages/settings/tienda/integration-dialog.component';
import { IntegrationConfigDialogComponent } from './pages/settings/tienda/integration-config-dialog.component';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { FormatcodePipe } from './pipes/format-codigo.pipe';
import { TipoVarianteComponent } from './pages/settings/tipo-variante/tipo-variante.component';
import { CreateEditTipoVarianteComponent } from './pages/settings/tipo-variante/create-edit-tipo-variante/create-edit-tipo-variante.component';
import { VoucherTypesComponent } from './pages/settings/voucher-types/voucher-types.component';
import { CreateVoucherTypeComponent } from './pages/settings/voucher-types/create-voucher-type/create-voucher-type.component';
import { ProduccionComponent } from './pages/produccion/produccion.component';
import { TurnosEditUpdateComponent } from './pages/settings/turnos-list/turnos-edit-update/turnos-edit-update.component';
import { TurnosListComponent } from './pages/settings/turnos-list/turnos-list.component';
import { TurnosComponent } from './pages/produccion/turnos/turnos.component';
import { MatDialogModule } from '@angular/material/dialog';
import { TurnosAsignarComponent } from './pages/produccion/asignar-turno/asignar-turno.component';
import { RecetasComponent } from './pages/produccion/recetas/recetas.component';
import { RecetaEditCreateComponent } from './pages/produccion/recetas/receta-edit-create/receta-edit-create.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { AddEditInsumoComponent } from './pages/produccion/recetas/add-edit-insumo/add-edit-insumo.component';
import { OrdenAddEditComponent } from './pages/produccion/orden-add-edit/orden-add-edit.component';
import { OrdenesListComponent } from './pages/produccion/ordenes-list/ordenes-list.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { StatusChangeModalComponent } from './pages/produccion/ordenes-list/status-modal/status-change-modal.component';
import { EstadoColorPipe } from './pipes/estadoColor.pipe';
import { ProductionRequirementsDialogComponent } from './pages/produccion/orden-add-edit/production-requirements-dialog.component';
import { ConversionUnitsDialogComponent } from './pages/productos/detalle-producto/conversion-units-dialog/conversion-units-dialog.component';
import { AlmacenesListComponent } from './pages/settings/almacenes/almacenes-list/almacenes-list.component';
import { AlmacenAddEditComponent } from './pages/settings/almacenes/almacen-add-edit/almacen-add-edit.component';
import { CapitalizePipe } from './pipes/capitalize.pipe';
import { ParseDatePipe } from './pipes/parse-date.pipe';
import { ListaFormasPagoComponent } from './pages/caja/lista-formas-pago/lista-formas-pago.component';
import { ConfirmacionVentaComponent } from './pages/caja/confirmacion-venta/confirmacion-venta.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ProveedorTabComponent } from './pages/productos/detalle-producto/proveedor-tab/proveedor-tab.component';
import { ProveedorDialogComponent } from './pages/productos/detalle-producto/proveedor-dialog/proveedor-dialog.component';
import { ProductosProveedorTabComponent } from './pages/clientes/detalle-cliente/productos-proveedor-tab.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatListModule } from '@angular/material/list';
import { CentroCostosIndirectosComponent } from './pages/produccion/centro-costos-indirectos/centro-costos-indirectos.component';
import { UserRoleDialogComponent } from './pages/settings/user/user-role-dialog/user-role-dialog.component';
import { MatDividerModule } from '@angular/material/divider';
import { UserComponent } from './pages/settings/user/user.component';
import { DevolucionesComponent } from './pages/devoluciones/devoluciones.component';
import { CrearDevolucionComponent } from './pages/devoluciones/crear-devolucion/crear-devolucion.component';
import { DetalleDevolucionComponent } from './pages/devoluciones/detalle-devolucion/detalle-devolucion.component';
import { ProcesarDevolucionComponent } from './pages/caja/procesar-devolucion/procesar-devolucion.component';
import { IntegrationsListComponent } from './pages/settings/integrations/integrations-list.component';

import { UserProfileComponent } from './pages/settings/user/user-profile/user-profile.component';
import { CreateEditIntegrationComponent } from './pages/settings/integrations/create-edit-integration.component';
import { CargaExcelProductosComponent } from './pages/productos/carga-excel-productos/carga-excel-productos.component';

@NgModule({
  declarations: [
    EstadoColorPipe,
    AppComponent,
    AdminLayoutComponent,
    ClientesComponent,
    DetalleClienteComponent,
    ProductosComponent,
    DetalleProductoComponent,
    ComponenteDialogoComponent,
    ImpuestosDialogComponent,
    InfoDialogComponent,
    ResumenComponent,
    SaldoInicialDialogComponent,
    ConfirmarDialogComponent,
    VentasComponent,
    ComprobanteComponent,
    ListaClienteComponent,
    CajaComponent,
    AperturaComponent,
    CierreComponent,
    SettingsComponent,
    PuntoVentaComponent,
    CreatePtoVentaComponent,
    ListaPrecioComponent,
    ListaFormasPagoComponent,
    ConfirmacionVentaComponent,
    CreateListaPrecioComponent,
    ProductosDialogoComponent,
    ListaClienteCajaComponent,
    ListaProductosDialogoComponent,
    ConfirmarCajaComponent,
    MarcasComponent,
    CreateMarcaComponent,
    RubrosComponent,
    CreateRubroComponent,
    UploadFileComponent,
    ComprasComponent,
    ReportesComponent,
    FormatcodePipe,
    FormatComprobantePipe,
    FormatPtoventaPipe,
    FormatEstadoPipe,
    ReporteStockComponent,
    EditarCantidadesComponent,
    EmpresaComponent,
    CheckauthComponent,
    TablaResponsivaComponent,
    DetalleFilaComponent,
    RecibosComponent,
    DialogComprobantesComponent,
    DialogMediosPagoComponent,
    ProductosProveedorComponent,
    PreciosMasivosComponent,
    FileDragAndDropDirective,
    VariantesArticuloComponent,
    GoBackBtnComponent,
    TalonariosComponent,
    CreateTalonarioComponent,
    StatusChangeModalComponent,
    TiendaComponent,
    IntegrationDialogComponent,
    IntegrationConfigDialogComponent,
    TipoVarianteComponent,
    CreateEditTipoVarianteComponent,
    VoucherTypesComponent,
    CreateVoucherTypeComponent,
    ProduccionComponent,
    TurnosListComponent,
    TurnosEditUpdateComponent,
    TurnosComponent,
    TurnosAsignarComponent,
    RecetasComponent,
    RecetaEditCreateComponent,
    AddEditInsumoComponent,
    OrdenAddEditComponent,
    OrdenesListComponent,
    ProductionRequirementsDialogComponent,
    ConversionUnitsDialogComponent,
    AlmacenesListComponent,
    AlmacenAddEditComponent,
    ProveedorTabComponent,
    ProveedorDialogComponent,
    CapitalizePipe,
    ParseDatePipe,
    ProductosProveedorTabComponent,
    AsociarProductosDialogComponent,
    CentroCostosIndirectosComponent,
    UserRoleDialogComponent,
    UserComponent,
    DevolucionesComponent,
    CrearDevolucionComponent,
    DetalleDevolucionComponent,
    ProcesarDevolucionComponent,
    IntegrationsListComponent,
    CreateEditIntegrationComponent,
    IntegrationsListComponent,
    CreateEditIntegrationComponent,
    UserProfileComponent,
    CargaExcelProductosComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    RouterModule.forRoot(AppRoutes, { useHash: false }),
    SidebarModule,
    NavbarModule,
    FooterModule,
    HttpClientModule,
    MatAutocompleteModule,
    MaterialModule,
    MatTableModule,
    ReactiveFormsModule,
    CalendarModule,
    StepsModule,
    CardModule,
    MatDialogModule,
    MatCardModule,
    MatDatepickerModule,
    FormsModule,
    DirectivesModule, // Añadir el módulo de directivas
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatButtonModule,
    MatListModule,
    MatIconModule,
    MatInputModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorHeadersInterceptor,
      multi: true,
    },
    { provide: MAT_DATE_LOCALE, useValue: 'es-AR' },
    {
      provide: LOCALE_ID, // Nuevo
      useValue: 'es-AR', // Nuevo
    },
    // Servicio mejorado de gestión de diálogos
    EnhancedDialogService,
    {
      provide: DEFAULT_CURRENCY_CODE, // Nuevo
      useValue: 'ARS', // Nuevo
    },
  ],
  bootstrap: [AppComponent],
  exports: [FormatcodePipe, FormatComprobantePipe, FormatPtoventaPipe, CapitalizePipe, ParseDatePipe],
  entryComponents: [AsociarProductosDialogComponent],
})
export class AppModule {}
